import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { MicNone as MicIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { colors } from '../theme';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.lightGray,
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center', py: 8 }}>
        <MicIcon sx={{ fontSize: 80, color: colors.gray, mb: 3 }} />
        <Typography variant="h4" sx={{ fontWeight: 700, color: colors.royalBlue, mb: 2 }}>
          找不到頁面
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          您訪問的頁面不存在
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{ backgroundColor: colors.royalBlue }}
        >
          返回獅聲心語
        </Button>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
